/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import Logo from '@/assets/delivery.png'

function ConveyorNode({ data, isConnectable }) {
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={Logo} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center text-sm">
            <b>Conveyor</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Right} />
    </div>
  )
}

export default ConveyorNode
